import { shape, string, func, bool, number } from 'prop-types';

export default shape({
  name: string.isRequired,
  dataField: string,
  dataType: string,
  label: string,
  calculateCellValue: func,
  sortable: bool,
  searchable: bool,
  filterable: bool,
  translatable: bool,
  width: number,
  grow: number,
  shrink: number
});
